module.exports = __webpack_public_path__ + "static/img/105.57de2c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/105.png
// module id = umQ3
// module chunks = 0